var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure"},[_c('img',{staticClass:"img",attrs:{"src":_vm.item1}}),_c('img',{staticClass:"img",attrs:{"src":_vm.item2}}),_c('img',{staticClass:"img",attrs:{"src":_vm.item3}})])
}
var staticRenderFns = []

export { render, staticRenderFns }